import { Card, CardHeader, Stack, IconButton, Tooltip } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialTypography from "../components/MaterialTypography";
import { FaRegEye } from "react-icons/fa";
import { useEffect, useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import BASEURL from "../pages/Utils/Baseurl";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";

import { apicall } from "../Integration/apicall";
import { getallrecruitmentprocess } from "./query";
import RequestDialog from "./requestdialog";
import { updaterecruitmentproceesdata } from "./mutation";
import Swal from "sweetalert2";
import { FaRegCheckCircle } from "react-icons/fa";
import AnimatedClockIcon from "../components/Icon/animatedClockIcon";

const Procedure = () => {
  const nav = useNavigate();
  const [currentrequest, setcurrentrequest] = useState("");
  const [RecruitmentRows, setRecruitmentRows] = useState([]);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [recruitmentdata, setrecruitmentdata] = useState({});

  const handlecurrentrequest = (request, data) => {
    console.log(data, "requesteddata");
    setrecruitmentdata({});
    setcurrentrequest(request);
    setrecruitmentdata(() => ({
      recruitmentproceesid: data?.recruitmentProcess?.id,
      appointmentletterid:
        data?.recruitmentProcess?.appointmentLetterInstance?.[0]?.id || 0,
      empCode:
        data?.recruitmentProcess?.appointmentLetterInstance?.[0]?.empCode || "",
      appointmentctc:
        data?.recruitmentProcess?.appointmentLetterInstance?.[0]?.ctc || "",
      appointmentbasicPercentage:
        data?.recruitmentProcess?.appointmentLetterInstance?.[0]
          ?.basicPercentage || "",
      appointmentsalaryStructure:
        {
          value:
            data?.recruitmentProcess?.appointmentLetterInstance?.[0]
              ?.salaryStructure?.id,
          label:
            data?.recruitmentProcess?.appointmentLetterInstance?.[0]
              ?.salaryStructure?.structureName,
        } || "",
      appointmentdate:
        data?.recruitmentProcess?.appointmentLetterInstance?.[0]?.date || "",
    }));
    setOpen(true);
  };
  const handlerecruitmentchange = (field, value) => {
    setrecruitmentdata((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    onDepartmentdata();
  }, []);

  const [setdepartmentnames] = useState([]);
  const onDepartmentdata = async () => {
    const query = `query {
          allDepartment {
              id
              departmentName
              departmentCode
          }
      }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const departmentList = response.data.data.allDepartment;
      setdepartmentnames(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const handlenda = (recruirement) => {
    console.log(recruirement, "recdata");
    nav("/Nda", {
      state: {
        candidateName:
          recruirement?.technicalFeedback?.sourcingScreening?.candidateName,
        employeeAddress: recruirement?.technicalFeedback?.employeeAddress,
        location: recruirement?.technicalFeedback?.sourcingScreening?.location,
      },
    });
  };

  const RecruitmentColumns = [
    {
      field: "jobid",
      headerName: "Job ID",
      width: 90,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
      sticky: true,
    },
    {
      field: "candidateName",
      headerName: "Name",
      width: 140,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      sticky: true,
    },
    {
      field: "position",
      headerName: "Position",
      width: 180,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      sticky: true,
    },

    {
      field: "documentVerification",
      headerName: "Document Verification",
      width: 150,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "nda",
      headerName: "NDA",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "appointmentLetter",
      headerName: "Appointment Letter",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "hrInduction",
      headerName: "HR Induction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "technicalInduction",
      headerName: "Technical Induction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "teamIntro",
      headerName: "Team Introduction",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "assestHandover",
      headerName: "Asset Handover",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "hrmsAccess",
      headerName: "HRMS Access",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "handoverToManager",
      headerName: "Handover To Manager",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
  ];

  const [open, setOpen] = useState(false);

  useEffect(() => {
    getrecruitmentprocess();
  }, []);

  const handleupdaterecruitment = (feild, id) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are You Sure to Proceed Further ?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        updaterecruitmentprocess(feild, id);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const updaterecruitmentprocess = (feild, id) => {
    apicall(updaterecruitmentproceesdata, {
      id,
      input: {
        [feild]: true,
      },
    })
      .then((res) => {
        if (res.success) {
          const success = res?.data?.data?.updateRecruitmentProcess?.success;
          const message = res?.data?.data?.updateRecruitmentProcess?.message;

          Swal.fire({
            position: "center",
            icon: success ? "success" : "error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Cannot Able To update Procedure !",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Able To update Procedure !",
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .finally(() => {
        getrecruitmentprocess();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      });
  };

  const getrecruitmentprocess = () => {
    apicall(getallrecruitmentprocess)
      .then((res) => {
        if (res?.success) {
          let recruitment_data =
            res?.data?.data?.allRecruitmentAndHiredFeedback;
          recruitment_data = recruitment_data?.map((recruitment, ind) => ({
            id: ind + 1,
            recruitment_id: recruitment?.recruitmentProcess?.id || -1,
            jobid: recruitment?.technicalFeedback?.sourcingScreening?.jobid,
            candidateName:
              recruitment?.technicalFeedback?.sourcingScreening?.candidateName,
            position:
              recruitment?.technicalFeedback?.sourcingScreening?.position,
            hirringstatus: recruitment?.technicalFeedback?.hiringStatus,
            documentVerification: recruitment?.recruitmentProcess
              ?.documentVerification ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "documentVerification",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            nda: recruitment?.recruitmentProcess?.nda ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlenda(recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegEye color="#0B1D51" size={20} />
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "nda",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            appointmentLetter: recruitment?.recruitmentProcess
              ?.appointmentLetter ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("appointmentletter", recruitment)
                  }
                >
                  <MaterialBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      transition: "transform 1.0s ease",
                      "&:hover": {
                        transform: "scale(1.4)",
                      },
                    }}
                  >
                    <FaRegCheckCircle color="green" size={20} />
                  </MaterialBox>
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("appointmentletter", recruitment)
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            hrInduction: recruitment?.recruitmentProcess?.hrInduction ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "hrInduction",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            teamIntro: recruitment?.recruitmentProcess?.teamIntro ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "teamIntro",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            technicalInduction: recruitment?.recruitmentProcess
              ?.technicalInduction ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "technicalInduction",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            assestHandover: recruitment?.recruitmentProcess?.assestHandover ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "assestHandover",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),
            hrmsAccess: recruitment?.recruitmentProcess?.hrmsAccess ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "hrmsAccess",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            handoverToManager: recruitment?.recruitmentProcess
              ?.handoverToManager ? (
              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  transition: "transform 1.0s ease",
                  "&:hover": {
                    transform: "scale(1.4)",
                  },
                }}
              >
                <FaRegCheckCircle color="green" size={20} />
              </MaterialBox>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handleupdaterecruitment(
                      "handoverToManager",
                      recruitment?.recruitmentProcess?.id
                    )
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),
          }));

          setRecruitmentRows(recruitment_data);
        } else {
          alert("Something Went Wrong Try After Sometime !");
        }
      })
      .catch((err) => {
        alert("Cannot Able to Recruitment Data ", err?.message);
      });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                {/* Left: Title */}
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Procedure Details
                  </MaterialTypography>
                </Stack>

                {/* Right: Status Icons */}
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={1}
                  flexWrap="wrap"
                >
                  {/* View Document */}
                  <Tooltip
                    title="To preview uploaded or generated documents and download them if needed."
                    disableInteractive
                    arrow
                    placement="top"
                  >
                    <MaterialBox
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 4,
                        px: 1.5,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        backgroundColor: "#f9f9f9",
                        transition:
                          "transform 0.2s ease-in-out, box-shadow 0.2s",
                        cursor: "default",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 2px 10px rgba(17, 0, 255, 0.2)",
                          backgroundColor: "#e6eaffff",
                        },
                      }}
                    >
                      <FaRegEye color="#0B1D51" size={20} />
                      <MaterialTypography variant="caption" fontWeight={500}>
                        View Document
                      </MaterialTypography>
                    </MaterialBox>
                  </Tooltip>

                  {/* Process Completed */}
                  <Tooltip
                    title="This indicates that the process or action has been successfully completed."
                    disableInteractive
                    arrow
                  >
                    <MaterialBox
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 4,
                        px: 1.5,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        backgroundColor: "#f9f9f9",
                        transition:
                          "transform 0.2s ease-in-out, box-shadow 0.2s",
                        cursor: "default",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 2px 10px rgba(0, 128, 0, 0.2)",
                          backgroundColor: "#e6ffe6",
                        },
                      }}
                    >
                      <FaRegCheckCircle color="green" size={20} />
                      <MaterialTypography
                        variant="caption"
                        color="text.secondary"
                      >
                        Process Completed
                      </MaterialTypography>
                    </MaterialBox>
                  </Tooltip>

                  {/* Pending Progress */}
                  <Tooltip
                    title="This indicates that the process is still pending and requires action to be completed."
                    disableInteractive
                    arrow
                  >
                    <MaterialBox
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 4,
                        px: 1.5,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        backgroundColor: "#f9f9f9",
                        transition:
                          "transform 0.2s ease-in-out, box-shadow 0.2s",
                        cursor: "default",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 2px 10px rgba(255, 111, 0, 0.2)",
                          backgroundColor: "#fff5e6",
                        },
                      }}
                    >
                      <AnimatedClockIcon size={20} color="#FF6F00" />
                      <MaterialTypography
                        variant="caption"
                        color="text.secondary"
                      >
                        Pending Progress
                      </MaterialTypography>
                    </MaterialBox>
                  </Tooltip>
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          rows={RecruitmentRows}
          columns={RecruitmentColumns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={""}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No recruitment details found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any recruitment details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
      <MaterialBox>
        <RequestDialog
          open={open}
          setOpen={setOpen}
          currentrequest={currentrequest}
          recruitmentdata={recruitmentdata}
          handlerecruitmentchange={handlerecruitmentchange}
          setrecruitmentdata={setrecruitmentdata}
          confirmationDialog={confirmationDialog}
          setConfirmationDialog={setConfirmationDialog}
          getrecruitmentprocess={getrecruitmentprocess}
        />
      </MaterialBox>
    </DashboardLayout>
  );
};
export default Procedure;
